export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Recensioni degli ospiti",
    subtitle: "Chiedi una recensione su WhatsApp il giorno del check-out. Imposta il link dove desideri che gli ospiti lascino il loro feedback.",
    bulkNotice: "Questa modifica verrà applicata a tutti i {count} alloggi collegati a questo annuncio.",
    enableTitle: "Abilita le recensioni degli ospiti",
    enableSub: "Il giorno del check-out viene inviato automaticamente un messaggio WhatsApp per chiedere una recensione.",
    modeSingleTitle: "Un unico link",
    modeSingleSub: "Lo stesso per ogni prenotazione",
    modePerOtaTitle: "Un link per ogni OTA",
    modePerOtaSub: "In base al canale di prenotazione",
    linkLabel: "Link per la recensione",
    singleUrlPlaceholder: "https://g.page/r/… o il link alla tua pagina di recensioni",
    otaNamePlaceholder: "Nome del sito",
    otaUrlPlaceholder: "https://… link della recensione",
    removeTitle: "Rimuovi",
    addOta: "Aggiungi un altro sito",
    saving: "Salvataggio…",
    saveConfig: "Salva impostazioni",
    note: "Gli ospiti riceveranno il link corrispondente in base a come hanno prenotato.",
    toastLoadError: "Impossibile caricare i dati dell'annuncio.",
    urlErrorProtocol: "L'URL deve iniziare con http:// o https://",
    urlErrorInvalid: "Inserisci un URL valido (es. https://g.page/...)",
    toastStateUpdated: "Stato aggiornato correttamente",
    toastStateError: "Si è verificato un problema durante l'aggiornamento dello stato",
    toastUrlRequired: "Inserisci un URL prima di salvare",
    toastSaved: "Impostazioni salvate correttamente",
    toastSaveError: "Si è verificato un problema durante il salvataggio",
  },

  // AccessSummary.vue
  access: {
    tag: "Serrature e accessi",
    dynamicTitle: "Serratura intelligente collegata",
    dynamicDetail: "Ogni prenotazione genera automaticamente un nuovo codice e lo invia all'ospite.",
    chipCheckin: "Inviato al completamento del check-in",
    chipTime: "Inviato alle {time} il giorno dell'arrivo",
    chipManual: "Lo invii manualmente",
    staticTitle: "Serratura con codice fisso",
    staticDetail: "L'ospite riceve il codice della cassetta di sicurezza o della serratura per entrare.",
    noneTitle: "Consegno le chiavi di persona",
    noneDetail: "Concordi la consegna delle chiavi con l'ospite all'arrivo.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Aggiorna prezzo",
    saving: "Salvataggio…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Collega ogni unità di questo annuncio al relativo stabilimento Mossos (ogni unità può avere il proprio ID di polizia). I check-in vengono inviati automaticamente allo stabilimento corretto in base all'unità della prenotazione.",
    wholeListing: "Intero annuncio",
    wholeListingDefault: "Intero annuncio (predefinito)",
    unitNumber: "Unità #{id}",
    badgeSendError: "Errore di invio",
    badgeConnected: "Collegato",
    badgeNoCredentials: "Nessuna credenziale",
    emptyList: "Ancora nessuna connessione. Aggiungine una per ogni unità dell'annuncio.",
    addConnection: "Aggiungi connessione",
    editConnection: "Modifica connessione",
    newConnection: "Nuova connessione",
    unit: "Unità",
    unitPlaceholder: "Scegli l'unità",
    unitHint: "A quale unità dell'annuncio appartiene questo stabilimento.",
    step1Title: "Accesso al sito web dei Mossos",
    usuariLabel: "Usuari (sito web dei Mossos)",
    savedHint: "salvato",
    usuariPlaceholderKeep: "Lascia vuoto per non modificare",
    usuariPlaceholderNew: "Nome utente per l'accesso al sito web",
    passLabel: "Paraula de pas",
    passBlankHint: "vuoto per non modificare",
    passPlaceholder: "Password del sito web dei Mossos",
    validateHint: "Convalida per recuperare gli stabilimenti del tuo account.",
    searching: "Ricerca…",
    validateSearch: "Convalida e trova gli stabilimenti",
    step2Title: "Stabilimento per questa unità",
    establishmentPlaceholder: "Seleziona lo stabilimento",
    revalidateHint: "Convalida di nuovo per modificarlo.",
    validateAbove: "Convalida qui sopra per scegliere lo stabilimento per questa unità.",
    checkinTime: "Orario di fatturazione (arrivo)",
    checkoutTime: "Orario di partenza",
    cancel: "Annulla",
    savingBtn: "Salvataggio...",
    updateConnection: "Aggiorna connessione",
    saveConnection: "Salva connessione",
    warnCredentials: "Inserisci l'usuari e la paraula de pas per il sito web dei Mossos.",
    foundEstablishments: "Trovati {count} stabilimento/i. Scegli quello per questa unità.",
    noEstablishments: "Nessuno stabilimento trovato in questo account.",
    connectError: "Impossibile connettersi ai Mossos. Controlla il tuo usuari e la password.",
    validateFirst: "Convalida e scegli lo stabilimento per questa connessione.",
    savedOk: "Connessione Mossos salvata.",
    saveError: "Impossibile salvare la connessione.",
    saveErrorGeneric: "Errore durante il salvataggio della connessione Mossos.",
    confirmDelete: `Eliminare la connessione per "{unit}" ({id})?`,
    deletedOk: "Connessione eliminata.",
    deleteError: "Impossibile eliminare la connessione.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Ogni unità comunica i propri ospiti con un account SES Hospedajes. Puoi usarne uno solo per l'intero annuncio o assegnarne uno diverso ad alcune unità, ad esempio se ogni appartamento ha il proprio codice di stabilimento.",
    defaultName: "Stabilimento {code}",
    badgeConnected: "Collegato",
    badgeError: "Errore di convalida",
    badgePending: "Non convalidato",
    user: "Utente",
    lessor: "Locatore",
    establishment: "Stabilimento",
    appliesWhole: "Intero annuncio:",
    appliesUnits: "Unità:",
    noUnits: "Nessuna unità lo usa",
    allUnits: "Tutte le unità ({count})",
    moreUnits: "+{count} in più",
    andMore: "e altre {count}",
    emptyList: "Non hai ancora collegato alcun account SES Hospedajes.",
    withoutAccountTitle: "Senza account:",
    withoutAccountText: "I loro check-in non vengono comunicati a SES Hospedajes.",
    addAccount: "Aggiungi account",
    edit: "Modifica",
    remove: "Rimuovi",
    newTitle: "Nuovo account SES Hospedajes",
    editTitle: "Modifica account SES Hospedajes",
    aliasLabel: "Nome dell'account (facoltativo)",
    aliasPlaceholder: "Es.: Attici, Appartamento 2B",
    aliasHint: "Serve solo a riconoscerlo qui. Se lo lasci vuoto, viene mostrato con il codice dello stabilimento.",
    loginTitle: "Accesso al Ministero",
    loginSame: "Lo stesso utente e password",
    loginSameHint: "Inserisci solo i codici di questo account.",
    loginOwn: "Un altro utente e password",
    loginFrom: "Usa l'accesso di",
    passwordKeep: "Lasciala vuota per non cambiarla",
    passwordNeeded: "Inserisci la password del nuovo utente.",
    passwordShared: "Questo utente è usato da altri {count} account dell'annuncio: se cambi la password, viene aggiornata in tutti.",
    scopeTitle: "A quali unità si applica?",
    scopeWhole: "Intero annuncio",
    scopeWholeHint: "Lo usano le unità che non hanno un altro account.",
    scopeWholeTaken: "Lo è già «{name}».",
    scopeUnits: "Solo alcune unità",
    scopeUnitsHint: "Scegli tu quali.",
    unitNow: "ora: {name}",
    unitNowWhole: "ora: quello dell'intero annuncio",
    unitNowNone: "senza account",
    leftWithout: "senza account dopo il salvataggio. I loro check-in non verranno più comunicati a SES Hospedajes.",
    leftToWhole: "dopo il salvataggio la comunicazione avverrà con l'account dell'intero annuncio «{name}».",
    errUnits: "Scegli almeno un'unità.",
    errDefaultExists: "Questo annuncio ha già un account per tutte le sue unità.",
    errDuplicate: "Hai già questo account in questo annuncio. Modificalo e aggiungi le unità.",
    errCopyFrom: "Impossibile usare l'accesso di quell'account. Inseriscilo a mano.",
    savedValidated: "Account salvato e convalidato dal Ministero.",
    savedNotValidated: "Salvato, ma il Ministero non accetta i dati. Controllali.",
    savedUnchecked: "Account salvato. Il TRA non permette di verificare il token in anticipo: si saprà al primo invio.",
    passwordSynced: "Password aggiornata anche in {count} account con lo stesso utente.",
    removeTitle: "Rimuovere questo account?",
    removeNoUnits: "L'account «{name}» verrà rimosso. Nessuna unità lo sta usando.",
    removeToFallback: "«{name}» verrà rimosso. Le unità che lo usano ({units}) comunicheranno con l'account dell'intero annuncio «{fallback}».",
    removeToNothing: "«{name}» verrà rimosso. Le unità che lo usano ({units}) resteranno senza account e i loro check-in non verranno più comunicati a SES Hospedajes.",
    removeConfirm: "Sì, rimuovi",
    removed: "Account rimosso.",
    removeError: "Impossibile rimuovere l'account.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Caricamento degli account…",
    saving: "Salvataggio…",
    close: "Chiudi",
    show: "Mostra",
    hide: "Nascondi",

    badgeConnected: "Collegato",
    badgeError: "Errore di convalida",
    badgePending: "Non convalidato",
    badgeOnSend: "Si verifica all'invio",

    edit: "Modifica",
    remove: "Rimuovi",
    addAccount: "Aggiungi account",

    appliesWhole: "Intero annuncio:",
    appliesUnits: "Unità:",
    noUnits: "Nessuna unità lo usa",
    allUnits: "Tutte le unità ({count})",
    moreUnits: "+{count} in più",
    andMore: "e altre {count}",
    withoutAccountTitle: "Senza account:",

    scopeTitle: "A quali unità si applica?",
    scopeWhole: "Intero annuncio",
    scopeWholeHint: "Lo usano le unità che non hanno un altro account.",
    scopeWholeTaken: "Lo è già «{name}».",
    scopeUnits: "Solo alcune unità",
    scopeUnitsHint: "Scegli tu quali.",
    unitNow: "ora: {name}",
    unitNowWhole: "ora: quello dell'intero annuncio",
    unitNowNone: "senza account",
    leftToWhole: "dopo il salvataggio la comunicazione avverrà con l'account dell'intero annuncio «{name}».",

    aliasLabel: "Nome dell'account (facoltativo)",
    aliasPlaceholder: "Es.: Torre nord, Appartamento 301",
    loginFrom: "Usa l'accesso di",
    secretKeep: "Lascialo vuoto per non cambiarlo",

    errUnits: "Scegli almeno un'unità.",
    errDefaultExists: "Questo annuncio ha già un account per tutte le sue unità.",
    errDuplicate: "Hai già questo account in questo annuncio. Modificalo e aggiungi le unità.",
    errCopyFrom: "Impossibile usare l'accesso di quell'account. Inseriscilo a mano.",
    errNoListing: "Non troviamo l'annuncio. Riapri la schermata.",
    saveError: "Impossibile salvare l'account.",

    removeTitle: "Rimuovere questo account?",
    removeConfirm: "Sì, rimuovi",
    removeNoUnits: "L'account «{name}» verrà rimosso. Nessuna unità lo sta usando.",
    removeToFallback: "«{name}» verrà rimosso. Le unità che lo usano ({units}) comunicheranno con l'account dell'intero annuncio «{fallback}».",
    removeToNothing: "«{name}» verrà rimosso. Le unità che lo usano ({units}) resteranno senza account e non comunicheranno più a {authority}.",
    removed: "Account rimosso.",
    removeError: "Impossibile rimuovere l'account.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Ogni unità comunica i propri ospiti al SIRE con un account. Puoi usarne uno solo per l'intero annuncio o assegnarne uno diverso ad alcune unità, ad esempio se ogni appartamento è registrato con il proprio codice di stabilimento.",
      introSingle: "Collega l'account con cui questo annuncio comunica i propri ospiti al SIRE.",
      emptyList: "Non hai ancora collegato alcun account del SIRE.",
      withoutAccountText: "I loro check-in non vengono comunicati al SIRE.",
      newTitle: "Nuovo account del SIRE",
      editTitle: "Modifica account del SIRE",
      modalSub: "Sono i dati con cui accedi al SIRE",
      defaultName: "Stabilimento {code}",
      defaultNameDoc: "Documento {document}",
      docTypeLabel: "Tipo di documento",
      docType_CO_ID: "Carta d'identità per cittadini (cédula de ciudadanía)",
      docType_CO_FID: "Carta d'identità per stranieri (cédula de extranjería)",
      documentLabel: "Numero del documento",
      documentPlaceholder: "Es.: 1012345678",
      documentHint: "È l'utente con cui accedi al SIRE.",
      passwordLabel: "Password",
      passwordPlaceholder: "La password del SIRE",
      passwordShared: "Questo documento è usato da altri {count} account dell'annuncio: se cambi la password, viene aggiornata in tutti.",
      estLabel: "Codice di stabilimento (facoltativo)",
      estPlaceholder: "Es.: 67890",
      estHint: "Serve solo se con lo stesso accesso comunichi più alloggi. Se lo lasci vuoto, si usa quello che hai registrato.",
      loginTitle: "Accesso al SIRE",
      loginSame: "Lo stesso documento e password",
      loginSameHint: "Inserisci solo il codice di questo account.",
      loginOwn: "Un altro documento e password",
      aliasHint: "Serve solo a riconoscerlo qui. Se lo lasci vuoto, viene mostrato con il codice dello stabilimento.",
      metaDoc: "Documento",
      metaEst: "Stabilimento",
      leftWithout: "senza account dopo il salvataggio. I loro check-in non verranno più comunicati al SIRE.",
      errDocument: "Inserisci il numero del documento.",
      errPassword: "Inserisci la password del SIRE.",
      errPasswordNeeded: "Inserisci la password del nuovo documento.",
      savedValidated: "Account salvato e convalidato dal SIRE.",
      savedNotValidated: "Salvato, ma il SIRE non accetta i dati. Controllali.",
      savedUnchecked: "Account salvato. Il TRA non permette di verificare il token in anticipo: si saprà al primo invio.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Ogni unità invia il proprio report al TRA con un account. Puoi usarne uno solo per l'intero annuncio o assegnarne uno diverso ad alcune unità: ogni RNT identifica un alloggio.",
      introSingle: "Collega l'account con cui questo annuncio invia il proprio report al TRA.",
      emptyList: "Non hai ancora collegato alcun account del TRA.",
      withoutAccountText: "I loro soggiorni non vengono comunicati al TRA.",
      newTitle: "Nuovo account del TRA",
      editTitle: "Modifica account del TRA",
      modalSub: "Sono il token e il RNT di questo alloggio",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Incolla qui il tuo token",
      tokenHint: "Lo generi su",
      loginTitle: "Accesso al TRA",
      loginSame: "Lo stesso token",
      loginSameHint: "Inserisci solo il RNT di questo account.",
      loginOwn: "Un altro token",
      rntLabel: "RNT",
      rntPlaceholder: "Es.: 123456",
      rntHint: "Il Registro Nacional de Turismo di questo alloggio. È ciò che identifica lo stabilimento davanti al TRA.",
      aliasHint: "Serve solo a riconoscerlo qui. Se lo lasci vuoto, viene mostrato con il suo RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "senza account dopo il salvataggio. I loro soggiorni non verranno più comunicati al TRA.",
      errToken: "Incolla il token del TRA.",
      errRnt: "Il RNT è un numero. Controllalo.",
      savedValidated: "Account salvato e convalidato dal TRA.",
      savedNotValidated: "Salvato, ma il TRA non accetta i dati. Controllali.",
      savedUnchecked: "Account salvato. Il TRA non permette di verificare il token in anticipo: si saprà al primo invio.",
    },

    foreign: {
      ses: "SES Hospedajes (Spagna)",
      colombia: "SIRE e TRA (Colombia)",
      title: "Restano account di {name}",
      text: "Questo annuncio non è più di quel paese, quindi quell'account non comunica nulla. | Questo annuncio non è più di quel paese, quindi quei {count} account non comunicano nulla.",
      remove: "Rimuovili",
      removeTitle: "Rimuovere gli account in eccesso?",
      removeMessage: "Verrà rimosso l'account di {name} rimasto da prima. Non influisce sull'autorità che usi adesso. | Verranno rimossi i {count} account di {name} rimasti da prima. Non influisce sull'autorità che usi adesso.",
      removed: "Account rimossi.",
      removeError: "Impossibile rimuoverli.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Messaggio di check-out",
    subtitle: "Un promemoria di check-out inviato la sera prima della partenza. Scrivi il tuo testo e usa le variabili disponibili.",
    loading: "Caricamento…",
    enableTitle: "Invia messaggio di check-out",
    enableSub: "Verrà inviato automaticamente {day} alle {time}.",
    dayLast: "il giorno della partenza",
    dayBefore: "il giorno prima della partenza",
    cloneTitleNoun: "messaggio di check-out",
    cloneItemNoun: "il messaggio di check-out",
    whenLabel: "Quando viene inviato",
    dayBeforeShort: "Giorno prima",
    dayLastShort: "Giorno della partenza",
    atLabel: "Alle",
    timeHint: "Il giorno della partenza l'orario non può essere successivo al check-out ({time}).",
    otaTitle: "Invia anche tramite OTA",
    textLabel: "Testo del messaggio di check-out",
    translate: "Traduci",
    translating: "Traduzione…",
    attach: "Allega",
    uploading: "Caricamento…",
    attachTitle: "Allegati del messaggio di check-out",
    emojis: "Emoji",
    searchEmoji: "Cerca emoji…",
    variables: "Variabili",
    varsHint: "Tocca per inserirle. All'invio vengono sostituite con i dati reali della prenotazione.",
    uploadDone: "Inviato. Salvataggio sul server…",
    attachLimits: "Immagini e PDF fino a {file} MB · video MP4 fino a {video} MB.",
    attachLimitsWhy: "Questi sono i limiti consentiti da WhatsApp.",
    tipBefore: "Usa",
    tipTextWord: "testo",
    tipMid: "per rendere qualcosa in",
    tipBoldWord: "grassetto",
    tipAfter: "(formattazione WhatsApp). L'ospite riceve il messaggio nella propria lingua se configurata.",
    attachShared: "Allegati · condivisi tra tutte le lingue",
    delete: "Elimina",
    autosaveNote: "Le modifiche vengono salvate automaticamente.",
    preview: "Anteprima",
    online: "online",
    previewHint: "Si aggiorna con le tue impostazioni",
    dayOfCheckout: "Giorno della partenza",
    eveOfCheckout: "Vigilia della partenza",
    yourAccommodation: "il tuo alloggio",
    uploadSent: "{sent} di {total} MB",
    filesCount: "{count} file",
    placeholder: "es. Ciao {guest} 👋 Il tuo soggiorno presso {property} termina domani. L'orario di check-out è {time}. Grazie per la visita!",
    varGuestName: "Nome dell'ospite",
    varPropertyName: "Nome dell'alloggio",
    varCheckoutTime: "Orario di check-out",
    today: "oggi",
    tomorrow: "domani",
    previewDefault: "Ciao, *{guest}* 👋\n\nTi ricordiamo che il tuo soggiorno presso *{property}* termina {when}.\n\n🕚 L'orario massimo di check-out è *{time}*.\n\nGrazie mille per il tuo soggiorno. Buon viaggio! 😊",
    errVideoFormat: "❌ {name} è un video {ext} e WhatsApp supporta solo MP4. Convertilo in MP4 e caricalo di nuovo.",
    errFileSize: "❌ {name} è di {size} MB e il massimo è {max} MB. ",
    errFileSizeVideo: "WhatsApp non supporta video più grandi: comprimilo o accorcialo.",
    errFileSizeFile: "WhatsApp non supporta file più grandi.",
    attachUploaded: "Allegato/i caricato/i correttamente",
    attachUploadError: "Errore durante il caricamento degli allegati",
    attachDeleted: "Allegato eliminato",
    attachDeleteError: "Impossibile eliminare l'allegato",
    loadError: "Impossibile caricare il messaggio di check-out.",
    translateEmpty: "Scrivi il messaggio nella lingua attiva prima di tradurre.",
    translateSuccess: "{count} lingue tradotte! Controlla ogni scheda.",
    translatePartial: "{ok} tradotte, {fail} non riuscite.",
    translateError: "Impossibile tradurre. Riprova.",
    saved: "Messaggio di check-out salvato",
    saveError: "Impossibile salvare il messaggio di check-out.",
  },
};
